export const COMPOSER_KEYS = {
  main: 'composer',
  deviceTracking: 'device-tracking',
  deviceTrackingCustomer: 'device-tracking-customer',
  bulkArrival: 'bulk-arrival',
  bulkArrivalCustomer: 'bulk-arrival-customer',
} as const;

export const composerQueryKeys = {
  getDeviceTracking: (caseId?: string, ...args: unknown[]) =>
    [COMPOSER_KEYS.main, COMPOSER_KEYS.deviceTracking, caseId, ...args] as const,
  getDeviceTrackingCustomer: (caseId?: string, ...args: unknown[]) =>
    [COMPOSER_KEYS.main, COMPOSER_KEYS.deviceTrackingCustomer, caseId, ...args] as const,
  getBulkArrival: (...args: unknown[]) => [COMPOSER_KEYS.main, COMPOSER_KEYS.bulkArrival, ...args] as const,
  getBulkArrivalCustomer: (...args: unknown[]) =>
    [COMPOSER_KEYS.main, COMPOSER_KEYS.bulkArrivalCustomer, ...args] as const,
};
